<template>
  <div class="mbm breadcrumb-container">
    <div class="grid-container">
      <div
        class="grid-x"
        data-swiftype-index="false"
      >
        <div class="cell">
          <ul class="breadcrumbs">
            <li>
              <router-link 
                to="/"
              >
                <i class="fas fa-home" />
                <span class="accessible">Home</span>
              </router-link>
            </li>
            <li>
              <a href="/documents">Publications &amp; forms</a>
            </li>
            <li>
              <router-link 
                :to="{name: 'Index'}"
                v-html="postInfo.post_title"
              />
            </li>
            <li v-html="philaLink(pageInfo)" />
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>


<script>
export default {
  name: 'Breadcrumbs',
  props: {
    postInfo: {
      type: Object,
      required: true,
    },
    pageInfo: {
      type: String,
      required: true,
    },
  },
  methods: {
  },
};
</script>